<template>
  <div class="detail">
    <van-nav-bar @click-left="clickBack" title="详情" left-arrow v-if="mode != 'notice'" />

    <!-- 访客进入 -->
    <div class="card" v-if="type === 'vis'">
      <div class="title">被拜访人信息</div>
      <div class="panel">
        <div class="cell">
          <span class="headline">被访人姓名</span>
          <span>{{ data.acceptName }}</span>
        </div>
        <div class="cell">
          <span class="headline">预约时间</span>
          <span style="color: #454f63; font-size: 0.75rem">{{
            data.time
          }}</span>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="title">拜访人信息</div>
      <div class="panel flex flex-vc border-b">
        <img class="img" :src="data.photoImg" alt="" @click="previewImg(data.photoImg)" />
        <div class="info">
          <div class="name">{{ data.initiatorName }}</div>
          <span @click="getMobile(data, data.isShowMobile)" class="phone">{{ data.isShowMobile ? data.noMobile : data.visitorPhone }}</span>
          <van-icon  class="phone" style="margin-left: 3px;"
            @click="getMobile(data, data.isShowMobile)"
            v-if="!data.isShowMobile" name="eye-o" />
          <van-icon class="phone" style="margin-left: 3px;"
            @click="getMobile(data, data.isShowMobile)" v-if="data.isShowMobile" name="closed-eye" />

        </div>
      </div>
      <!-- <div class="panel"> -->
      <div class="cell">
        <span class="headline">预约时间</span>
        <span style="color: #454f63; font-size: 0.75rem">{{ data.time }}</span>
      </div>
      <!-- </div> -->
    </div>

    <div class="person-list" v-if="personList.length > 1">
      <div class="person-header">
        <span>同行人员</span>
      </div>
      <div class="person-item flex flex-vc" v-for="(item, index) in personList.slice(1)" :key="index">
        <div class="person-avatar">
          <img :src="item.photoImg" />
        </div>
        <div class="person-info flex-1">
          <div class="person-name">{{ item.visitorName }}</div>
          <span @click="getTeacherOrParentMobile(item, item.isShowMobile)" class="person-phone">{{ item.isShowMobile ? item.noMobile : item.visitorPhone }}</span>

          <van-icon  class="person-phone" style="margin-left: 3px;"
            @click="getTeacherOrParentMobile(item, item.isShowMobile)"
            v-if="!item.isShowMobile && item.name != '该学生未绑定家长'" name="eye-o" />
          <van-icon class="person-phone" style="margin-left: 3px;"
            @click="getTeacherOrParentMobile(item, item.isShowMobile)" v-if="item.isShowMobile" name="closed-eye" />
        </div>
      </div>
    </div>

    <!-- 暂存邀请码 -->
    <div class="card" v-if="data.auditStatus == 4">
      <div class="title">邀请码</div>
      <div class="panel" style="text-align: center">
        <div class="hint">
          <span>扫一扫或者点击下方的邀请人员，即可加入</span>
        </div>
        <div class="code" style="display: inline-block">
          <QRCode :url="qrcodeUrl"></QRCode>
        </div>
        <div class="invite-btn" @click="invite">
          <span>邀请人员</span>
        </div>
      </div>
    </div>

    <!-- 其他信息 -->
    <div class="card">
      <div class="title">其他信息</div>
      <div class="panel">
        <div class="cell">
          <span class="headline">所属单位</span>
          <span>{{ data.affiliatedUnit }}</span>
        </div>
        <div class="cell">
          <span class="headline">车牌号</span>
          <span>{{ data.carNumber }}</span>
        </div>
        <div class="cell">
          <span class="headline">预约事由</span>
          <span>{{ data.visitorGoal }}</span>
        </div>
        <div class="cell">
          <span class="headline">说明</span>
          <span>{{ data.remark }}</span>
        </div>
      </div>
    </div>

    <!-- 审批状态 -->
    <!-- <div class="card">
      <div class="title">审批信息</div>
      <div class="panel">
        <div class="cell">
          <span class="headline">审批人</span>
          <span>{{ data.acceptName }}</span>
        </div>
        <div class="cell">
          <span class="headline">审批时间</span>
          <span>{{ data.carNumber || "暂无审批时间" }}</span>
        </div>
        <div class="cell">
          <span class="headline">审批状态</span>
          <span>{{
            ["待审批", "已通过", "已驳回", "拜访完成", "正在审批"][
              data.auditStatus
            ] || "暂无审批状态"
          }}</span>
        </div>
      </div>
    </div> -->
    <!-- 健康码 行程码 核酸检测相关图片 -->
    <div class="card" v-if="nucleStatus">
      <div class="title_1">
        <span>预约人及同行人健康码</span>
        <span style="font-size: 0.85rem;"
          v-if="!(data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 0))"> : 暂无</span>
      </div>
      <div class="panel_1" v-if="data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 0)">
        <img class="img_1" @click="previewImg(img.imgUrl)"
          v-for="img in data.visitorHealthCertificate.filter(x => x.type == 0)" :key="img.imgUrl" :src="img.imgUrl"
          alt="">
      </div>
      <div class="title_1">
        <span>预约人及同行人行程码</span> <span
          v-if="!(data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 1))"> : 暂无</span>
      </div>
      <div class="panel_1" v-if="data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 1)">
        <img class="img_1" @click="previewImg(img.imgUrl)"
          v-for="img in data.visitorHealthCertificate.filter(x => x.type == 1)" :key="img.imgUrl" :src="img.imgUrl"
          alt="">
      </div>
      <div class="title_1">
        <span>预约人及同行人核酸检测证明</span> <span
          v-if="!(data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 2))"> : 暂无</span>
      </div>
      <div class="panel_1" v-if="data.visitorHealthCertificate && data.visitorHealthCertificate.some(x => x.type == 2)">
        <img class="img_1" @click="previewImg(img.imgUrl)"
          v-for="img in data.visitorHealthCertificate.filter(x => x.type == 2)" :key="img.imgUrl" :src="img.imgUrl"
          alt="">
      </div>
    </div>



    <!-- 审批步骤条 -->
    <div class="card" v-if="data.busAuditLevelList.length > 0">
      <div class="title">审批信息</div>
      <div class="panel">
        <van-steps direction="vertical">
          <van-step v-for="item in data.busAuditLevelList" :key="item.id">
            <!-- 自定义图标 -->
            <template #active-icon>
              <van-icon :name="['fail', 'success', 'cross'][item.auditStatus]"
                :class="['fail', 'success', 'cross'][item.auditStatus]" />
            </template>
            <template #inactive-icon>
              <van-icon :name="['fail', 'success', 'cross'][item.auditStatus]"
                :class="['fail', 'success', 'cross'][item.auditStatus]" />
            </template>

            <div :class="['fail_text', 'success_text', 'cross_text'][item.auditStatus]
              ">
              <span>{{ item.name }} </span><span>{{
                ["待审批", "已通过", "已驳回", "拜访完成", "正在审批"][
                item.auditStatus
                ] || "暂无审批状态"
              }}
              </span>

              <!-- 审批时间  -->
              <span v-if="item.createdTime">{{ ` ${item.createdTime}` || "暂无审批时间" }}</span>


              <!-- 备注 -->
              <p v-if="item.remark">
                {{ `备注: ${item.remark || "暂无备注"}` }}
              </p>
            </div>
          </van-step>
        </van-steps>
      </div>
    </div>


    <!-- 驳回理由 -->
    <!-- <div class="card" v-if="data.auditStatus == 2">
      <div class="title">驳回理由</div>
      <div class="panel" style="color: red">
        {{ data.rejectRemark }}
      </div>
    </div> -->

    <div class="btn-group">
      <van-row :gutter="20" class="btn-wrap" v-if="type !== 'vis' && data.auditStatus == 0 && isShowApprovalBtn(data)">
        <van-col :span="12">
          <van-button round type="warning" block @click="handleApprove(2)">驳回</van-button>
          <!-- <van-button round type="default" block @click="clickBack" v-else
            >返回</van-button
          > -->
        </van-col>
        <!--auditStatus 0审批 1审批通过 2审批未通过 3拜访完成 4正在审批 -1 已过期-->
        <van-col :span="12">
          <van-button round type="info" block @click="handleApprove(1)">通过</van-button>
          <!-- <van-button round type="primary" block v-if="data.auditStatus == 1"
            >审批通过</van-button
          >
          <van-button round type="danger" block v-if="data.auditStatus == 2"
            >审批未通过</van-button
          >
          <van-button round type="info" block v-if="data.auditStatus == 3"
            >拜访完成</van-button
          >
          <van-button round type="warning" block v-if="data.auditStatus == 4"
            >正在审批</van-button
          >
          <van-button round type="warning" block v-if="data.auditStatus == -1"
            >已过期</van-button
          > -->
        </van-col>
      </van-row>
      <van-row v-else style="margin: 0 3rem" :gutter="20">
        <van-col :span="24" v-if="mode != 'notice'">
          <van-button round type="info" block @click="clickBack">返回</van-button>
        </van-col>
        <!-- <van-col :span="12">
          <van-button round type="primary" block v-if="data.auditStatus == 1"
            >审批通过</van-button
          >
          <van-button round type="danger" block v-if="data.auditStatus == 2"
            >审批未通过</van-button
          >
          <van-button round type="info" block v-if="data.auditStatus == 3"
            >拜访完成</van-button
          >
          <van-button round type="warning" block v-if="data.auditStatus == 4"
            >正在审批</van-button
          >
          <van-button round type="warning" block v-if="data.auditStatus == -1"
            >已过期</van-button
          >
          <van-button round type="warning" block v-if="data.auditStatus == 0"
            >待审批</van-button
          >
        </van-col> -->
      </van-row>
    </div>

    <!-- <van-dialog v-model="show" show-cancel-button close-on-click-overlay :confirm-button-text="auditType ? '通过' : '驳回'" cancel-button-text="取消" title="温馨提示" @confirm="auditType ? audit(1) : audit(0)">
      <div class="dialog-wrap">
        <div class="wrap" v-if="auditType === 0">
          <div class="title">您是否驳回？</div>
          <input type="text" class="remak" placeholder="驳回理由" v-model="remark" />
        </div>
        <div class="wrap" v-else> -->
    <!-- <div class="title" style="color: #2a2e43;">您是否通过？</div> -->
    <!-- {{ dialogMsg }}
          <input type="text" class="remark-input" placeholder="备注" />
          <div v-if="columns.length > 0">
            <div class="dialog-item-title">选择下一位审批人</div>
            <div class="cell-wrap" @click="showSelectPerson = true">{{ pickerItem.deptName || "" }} {{ pickerItem.name || "" }}</div>
          </div>
        </div>
      </div>
    </van-dialog>
    <van-popup v-model="showSelectPerson" round position="bottom" :style="{ height: '40%' }">
      <van-picker show-toolbar title="选择审批人" :columns="columns" @confirm="handleConfirm" ref="picker" @cancel="showSelectPerson = false" value-key="name" />
    </van-popup> -->





    <!-- 选择审批人弹窗 -->
    <van-dialog v-model="show" show-cancel-button close-on-click-overlay :confirm-button-text="auditType ? '通过' : '确认'"
      cancel-button-text="取消" cancel-button-color="#000" confirm-button-color="#000"
      @confirm="auditType == 1 ? audit(1) : audit(2)">
      <div class="dialog-wrap">



        <!-- 驳回  -->
        <div class="wrap" v-if="auditType === 2">
          <div class="title">您是否驳回？</div>
          <input type="text" class="remak" placeholder="驳回理由" v-model="remark" />
        </div>




        <!-- 通过  -->
        <div class="wrap" v-else>
          <div class="title">{{ dialogMsg }}</div>

          <div v-if="columns.length > 0">
            <div class="dialog-item-title">审批人</div>

            <div class="cell-wrap">



              <div class="cell-wrap_item" @click.stop="handelClickAudit(item, index)" v-for="(item, index) in nowAuditList"
                :key="item.id">
                <!-- 删除图标 -->

                <div class="audit_close" v-if="item.auditStatus == 0 && isShowClose(index)"
                  @click.stop="nowAuditList.splice(index, 1)">
                  <van-icon name="cross" />
                </div>

                <!-- 通过图标 -->
                <div class="audit_allow" v-if="item.auditStatus == 1">
                  <van-icon name="success" />
                </div>

                <img :src="item.avatar" alt="" />
                <span>{{ item.name }}</span>

              </div>


              <div class="cell-wrap_add" @click.stop="() => {
                nowAuditIndex = undefined;
                $refs.interviewee.showiIntervieweePopup = true
              }">
                <van-icon name="plus" />
              </div>
            </div>
          </div>
        </div>


      </div>
    </van-dialog>



    <van-popup v-model="showSelectPerson" round position="bottom" :style="{ height: '40%' }">
      <van-picker show-toolbar title="选择审批人" :columns="columns" @confirm="handleConfirm" ref="picker"
        @cancel="showSelectPerson = false" value-key="name" />
    </van-popup>



    <!-- 添加选择审批人弹窗 -->
    <Interviewee ref="interviewee" @selectItem="handleSelIntervieweeItem" pageType="teacher" />
  </div>
</template>

<script>
import updatePersinList from "@/components/subScribePopup/updatePersinList";
import QRCode from "@/components/subScribePopup/qrcode";
import { baseUrl } from "@/constant/";
import { getDateYMD } from "@/utils";
import { ImagePreview } from "vant";
import moment from "moment";
export default {
  components: {
    updatePersinList,
    Interviewee: () => import("@/components/subScribePopup/interviewee.vue"),
    QRCode,
  },
  data() {
    return {
      data: {},
      show: false,
      remark: "",
      auditType: "",
      personListLen: -1,
      personList: [],
      rejectRemark: "",
      //审批通过需要的数据
      dialogMsg: "",
      showSelectPerson: false,
      columns: [],
      pickerItem: {},
      // 人员列表
      deptList: [],
      // 审核步骤条测试数据
      stepData: [
        { name: "刘强", state: "1", time: "2022-04-07 14:20" },
        { name: "孙丽", state: "2", time: "2022-04-07 14:25" },
        { name: "张丽宝", state: "0", time: "" },
      ],
      // 是否显示核酸板块
      nucleStatus: false,
      // 当前审批人列表
      nowAuditList: [],
      nowAuditIndex: undefined

    };
  },
  computed: {
    id() {
      console.log("this.$route.query.id", this.$route.query.id);
      return this.$route.query.id;
    },
    type() {
      console.log("this.$route.query.type", this.$route.query.type);
      return this.$route.query.type;
    },
    mode() {
      console.log("this.$route.query.mode", this.$route.query.mode);
      return this.$route.query.mode || "normal";
    },
    qrcodeUrl() {
      return `https://ai-prod.asiait.net?schoolId=${this.$store.state.schoolId}&visitorId=${this.id}`;
    },
  },

  mounted() {
    this.getSubDetail();
    this.getSysSchool()
    // this.personListLen =
    //   this.$refs.person && this.$refs.person.personList.length
  },
  methods: {


    // 获取后台配置权限
    async getSysSchool() {
      const { data, code, msg } = await this.$https.getSysSchool({
        // dictType: 'school_function_param',
        schoolId: localStorage.getItem("schoolId")
        // schoolId:"1070770900580810752"
      });
      if (code !== 200) {
        // this.$toast('')
        return;
      }
      // 核酸模块是否必填
      this.nucleStatus = data.some((item) => item.functionDictCode == 29);
    },


    // 判断是否显示通过审核按钮
    isShowApprovalBtn(data) {
      console.log('data', data)
      // 当前审批人是待审批状态并且前一个审批人的状态是已审批
      let userId = this.$store.state.userId
      // 查找审批信息中是否有当前审批人
      let personIndex = data.busAuditLevelList.findIndex(item => item.designatedPersonId == userId)

      if (personIndex != -1) {
        if (data.busAuditLevelList.length == 1 && data.busAuditLevelList[personIndex].auditStatus == 0) {
          return true
        } else {
          if (personIndex == 0) {
            if (data.busAuditLevelList[0].auditStatus == 0) {
              return true
            } else {
              return false
            }
          } else {
            if (data.busAuditLevelList[personIndex - 1].auditStatus == 1 && data.busAuditLevelList[personIndex ].auditStatus == 0) {
              return true
            } else {
              return false
            }
          }

        }
      } else {
        return false
      }
    },

    // 判断是否能删除审核人
    isShowClose(index) {
      let newIndex = this.nowAuditList.findIndex(x => x.id == this.$store.state.userId)
      return index > newIndex
    },

    // 点击审批人进行审批人更换
    handelClickAudit(item, index) {
      // 当前审批人只能修改自己之后的审批人信息
      // 获取当前审核人在列表中的位置
      let newIndex = this.nowAuditList.findIndex(x => x.id == this.$store.state.userId)
      console.log('newIndex', index)
      if (index > newIndex) {
        this.nowAuditIndex = index
        this.$refs.interviewee.showiIntervieweePopup = true;
      }
    },

    //获取下一个人批人列表
    async getUserDeptListAll() {
      const { data } = await this.$https.getUserDeptListAll({
        schoolId: this.$store.state.schoolId,
      });
      if (data.length == 0) {
        // this.$toast('搜索不到当前人员，请检查后重试')
        return false;
      }
      this.deptList = data;
      console.log("this.personList", this.personList);
      // this.searchNameList = data
      let filterData = data.filter(
        (item) => item.id !== this.$store.state.userId
      );
      let obj = {};
      filterData.forEach((item) => {
        if (!obj[item.deptName]) {
          obj[item.deptName] = [];
        }
        obj[item.deptName].push(item);
      });

      let columns = [];
      for (const key in obj) {
        columns.push({
          name: key,
          children: obj[key],
        });
      }
      this.columns = columns; // 获取学校的各个部门
      console.log('columns', columns);
    },


    // 选中的人员信息
    handleSelIntervieweeItem(item) {
      console.log('item', item)
      // 判断有无当前审批人
      if (this.nowAuditList.some(x => x.id == item.id)) {
        this.$toast('当前审批人已存在，请勿重复添加')
        return
      }

      // 判断是添加还是修改人员
      if (this.nowAuditIndex == undefined) {
        this.nowAuditList.push({
          id: item.id,
          avatar: item.avatar,
          name: item.name,
          auditStatus: 0
        })
      } else {
        this.nowAuditList.splice(this.nowAuditIndex, 1, {
          id: item.id,
          avatar: item.avatar,
          name: item.name,
          auditStatus: 0
        })
      }



      this.pickerItem = item;
    },



    //选择下一个审批人 ( 无用 )
    handleConfirm(value, indexs) {
      console.log(value, indexs, "del详情");
      const columns1 = this.$refs.picker.getColumnValues(1);
      this.pickerItem = columns1[indexs[1]];
      this.showSelectPerson = false;
    },



    // 图片预览
    previewImg(imgurl) {
      ImagePreview({
        images: [imgurl],
        closeOnPopstate: true,
      });
    },


    // 返回
    clickBack() {
      // if (this.type == 'vis') {
      //   this.$router.replace('/visitor')
      // } else {
      //   this.$router.replace('/approval')
      // }
      this.$router.go(-1);
    },


    invite() {
      this.$toast("点击右上角按钮，分享给朋友");
    },



    // 打开 通过 || 驳回弹窗
    handleApprove(type) {
      this.show = true;
      this.auditType = type;
      this.dialogMsg = `${this.data.initiatorName} ${this.data.affiliatedUnit ? '(' + this.data.affiliatedUnit + ')' : ''}来访，您是否审核通过？`;
    },


    // 详情
    async getSubDetail() {
      await this.getUserDeptListAll();
      const { data, code } = await this.$https.getVisitorDetail({
        visitorId: this.id,
        // visitorId:'1259320037833035776'
      });
      if (code !== 200) {
        this.$toast("获取详情失败");
        return false;
      }
      data.isShowMobile = false
      this.data = data;

      console.log(this.data, data, "审批详情页的某一个");
      // this.data.visitorBeginTime = getDateYMD(data.visitorBeginTime)
      // this.data.visitorEndTime = moment(data.visitorEndTime).format('mm-ss')
      console.log("查看是否拿到人员列表", this.deptList);
      // 审批数据时间和人名转换
      this.data.busAuditLevelList.forEach((item) => {
        let obj = this.deptList.find(
          (person) => person.id == item.designatedPersonId
        );
        // 姓名
        item.name = obj.name;
        item.avatar = obj.avatar
        item.createdTime = item.createdTime && moment(item.createdTime).format("YYYY-MM-DD HH:mm");
      });

      // 设置当前审批人列表
      this.nowAuditList = JSON.parse(JSON.stringify(this.data.busAuditLevelList.map(item => {
        return {
          id: item.designatedPersonId,
          auditStatus: item.auditStatus,
          avatar: item.avatar,
          name: item.name
        }
      })))

      // 对请假时间进行跨天和跨年判断

      this.data.time = this.setVisitorTime(data.visitorBeginTime,data.visitorEndTime)
      this.getPersonList(data.id);

    },

    // 对预约时间进行跨天和跨年判断
    setVisitorTime (start,end) {
      let startTime = moment(start).format('YYYY-MM-DD')
      let endTime = moment(end).format('YYYY-MM-DD')

      let startYear = moment(start).format('YYYY')
      let endYear = moment(end).format('YYYY')

      if (startTime == endTime) { // 日期相同
        return `${moment(start).format('YYYY-MM-DD HH:mm')} - ${moment(end).format('HH:mm')}`
      } else { // 跨天审批
        if (startYear == endYear) { // 不跨年
          return `${moment(start).format('YYYY-MM-DD HH:mm')} - ${moment(end).format('MM-DD HH:mm')}`
        } else { // 跨年
          return `${moment(start).format('YYYY-MM-DD HH:mm')} - ${moment(end).format('YYYY-MM-DD HH:mm')}`
        }
      }

    },

    // 点击获取同行人手机号
    getTeacherOrParentMobile(data, bol) {
      if (!data.noMobile) { // 没有手机号
        this.$https.getFollowMobile({
          id: data.id
        }).then(res => {
          if (res.code == 200) {
            data.noMobile = res.data
            data.isShowMobile = !bol

          } else {
            this.$toast(res.msg)
          }
        })
      } else { // 有手机号
        data.isShowMobile = !bol

      }
    },
// 点击获取预约人手机号
getMobile(data, bol) {
      if (!data.noMobile) { // 没有手机号
        this.$https.getVisitorMobile({
          id: data.id
        }).then(res => {
          if (res.code == 200) {
            data.noMobile = res.data
            data.isShowMobile = !bol

          } else {
            this.$toast(res.msg)
          }
        })
      } else { // 有手机号
        data.isShowMobile = !bol
      }
    },


    async getAuditList(type) {
      const { data, code, msg } = await this.$https.getAuditList({
        auditType: type,
        userId: this.$store.state.userId,
      });
      if (code !== 200) {
        this.$toast(msg);
        return false;
      }
      return Promise.resolve(data);
    },


    async audit(status) {
      console.log('status', status)
      // return 
      if (status == 1) {
        this.$toast({
          type: "loading",
          message: "审批中...",
          overlay: true,
          duration: 0,
          forbidClick: true,
        });
      } else {
        this.$toast({
          type: "loading",
          message: "驳回中...",
          overlay: true,
          duration: 0,
          forbidClick: true,
        });
      }
      const { code, msg } = await this.$https.audit({
        auditStatus: status,
        acceptId: this.$store.state.userId,
        visitorId: this.data.id,
        auditIds: status == 1 ? this.nowAuditList.map(item => item.id) : this.data.busAuditLevelList.map(x => x.designatedPersonId),
        remark: this.remark,
      });
      if (code !== 200) {
        this.$toast(msg);
        this.getAuditList(0);
        this.getAuditList(1);
        return false;
      }

      // 审批通过执行逻辑
      if (status == 1) {
        // const res = await this.$https.getAuditStatus({
        //   visitId: this.data.id,
        // })
        // if (res.code !== 200) {
        //   this.$toast(res.msg)
        //   return
        // }
        this.$toast("审批通过");
        this.data.auditStatus = 1;
        this.getSubDetail();
      } else {
        this.$toast("驳回成功");
        this.data.auditStatus = 2;
        // 驳回成功后刷新当前页面
        this.getSubDetail();
      }
    },


    async getPersonList(id) {
      const { data, code } = await this.$https.getPersonList({
        visitorId: id,
      });
      if (code !== 200) {
        this.$toast("获取人员失败");
        return false;
      }
      data.forEach(item => {
        item.isShowMobile = false
      })
      this.personList = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.border-b {
  border-bottom: 1px solid #f4f4f6;
}

.detail {
  padding-bottom: 10rem;
}

.card {
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #fff;
  margin: 1rem;
  border-radius: 0.75rem;

  .title {
    color: rgba(120, 132, 158, 1);
    font-size: 0.85rem;
    padding: 0.6rem 1.25rem;
    border-bottom: 1px solid rgba(244, 244, 246, 0.99);
  }

  .title_1 {
    color: rgba(120, 132, 158, 1);
    font-size: 0.85rem;
    padding: 0.6rem 1.25rem;
  }

  .panel {
    padding-top: 1rem;
    margin: 0 1rem;
    padding-bottom: 1rem;

    .hint {
      color: rgba(120, 132, 158, 1);
      font-size: 0.75rem;
      margin-bottom: 0.75rem;
    }

    .invite-btn {
      margin: 0.5rem 0;

      span {
        padding: 0.65rem 1rem;
        display: inline-block;
        color: rgba(120, 132, 158, 1);
        background: rgba(233, 235, 239, 1);
        font-size: 0.75rem;
        border-radius: 0.85rem;
      }
    }

    .img_1 {
      width: 4rem;
      height: 4rem;
      border-radius: .4rem;
      margin-right: 0.75rem;
      object-fit: cover;
    }

    .img {
      width: 4.125rem;
      height: 4.125rem;
      border-radius: 50%;
      margin-right: 0.75rem;
      object-fit: cover;
    }

    .info {
      flex: 1;

      .name {
        color: #454f63;
        font-size: 1.5rem;
        font-weight: bold;
      }

      .phone {
        color: #cad1e2;
        font-size: 0.875rem;
        margin-top: 0.25rem;
      }
    }

    .or {
      margin: 0.5rem 0;
      color: #78849e;
    }

    .center {
      text-align: center;
    }

    .time {
      font-size: 1rem;
      color: #78849e;
    }
  }

  .panel_1 {
    /* display: flex; */
    /* padding: 0rem 1rem 1rem 1rem; */
    padding: 1rem 0;
    margin: 0 1rem;
    border-bottom: 1px solid rgba(244, 244, 246, 0.99);

    // padding-bottom: 1rem;
    /* align-items: center; */
    .hint {
      color: rgba(120, 132, 158, 1);
      font-size: 0.75rem;
      margin-bottom: 0.75rem;
    }

    .invite-btn {
      margin: 0.5rem 0;

      span {
        padding: 0.65rem 1rem;
        display: inline-block;
        color: rgba(120, 132, 158, 1);
        background: rgba(233, 235, 239, 1);
        font-size: 0.75rem;
        border-radius: 0.85rem;
      }
    }

    .img_1 {
      width: 4rem;
      height: 4rem;
      border-radius: .4rem;
      margin-right: 0.75rem;
      object-fit: cover;
    }

    .img {
      width: 4.125rem;
      height: 4.125rem;
      border-radius: 50%;
      margin-right: 0.75rem;
      object-fit: cover;
    }

    .info {
      flex: 1;

      .name {
        color: #454f63;
        font-size: 1.5rem;
        font-weight: bold;
      }

      .phone {
        color: #cad1e2;
        font-size: 0.875rem;
        margin-top: 0.25rem;
      }
    }

    .or {
      margin: 0.5rem 0;
      color: #78849e;
    }

    .center {
      text-align: center;
    }

    .time {
      font-size: 1rem;
      color: #78849e;
    }
  }
}

.cell {
  padding: 0.5rem 0;
  color: #454f63;
  font-size: 0.875rem;

  .headline {
    display: inline-block;
    color: #78849e;
    font-size: 0.75rem;

    margin-right: 1rem;
    width: 4rem;
    text-align: right;
  }
}

.btn-group {
  /* position: fixed; */
  /* bottom: 4rem; */
  width: 100%;
  margin-top: 2.5rem;

  /* left: 0; */
  .btn-wrap {
    padding: 0 2rem;
  }
}

.person-list {
  margin: 1rem 1rem 0;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #ffffff;
  border-radius: 0.75rem;

  .person-header {
    display: flex;
    justify-content: space-between;
    padding: 1rem 1.25rem;

    >span {
      color: rgba(120, 132, 158, 1);
      font-size: 0.75rem;
    }

    >div {
      .iconfont {
        font-size: 0.75rem;
      }

      font-size: 0.875rem;
      color: rgba(52, 151, 253, 1);
    }
  }

  .person-item {
    padding: 1rem 0;
    margin: 0 1rem;
    border-bottom: 1px solid rgba(244, 244, 246, 0.99);
    margin-bottom: 0.6rem;

    &:last-child {
      border-bottom: none;
    }

    .person-name {
      color: rgba(69, 79, 99, 1);
      font-size: 1rem;
      font-weight: 400;
      margin-bottom: 0.125rem;
    }

    .person-phone {
      color: rgba(120, 132, 158, 1);
      font-size: 0.875rem;
    }

    .person-avatar {
      margin-right: 1rem;

      img {
        width: 3rem;
        height: 3rem;
        border-radius: 0.75rem;
        margin: 0 auto;
        display: block;
        object-fit: cover;
      }
    }

    .handle {
      background: rgba(233, 235, 239, 1);
      border-radius: 0.5rem;
      font-size: 0.6875rem;
      width: 5rem;
      height: 2rem;
      text-align: center;
      line-height: 2rem;
      color: rgba(120, 132, 158, 1);
    }
  }
}

//通过理由输入框样式
.remark-input {
  background: #f7f7fa;
  border: none;
  padding: 10px 15px;
  width: 100%;
  border-radius: 20px;
  margin: 10px 0;
}

//选择下一个人批人样式
.dialog-item-title {
  //  color: #78849e;
  color: #333;
  //   font-size: 12px;
  margin: 10px 1rem;
}

.cell-wrap {
  padding: 10px 15px 0;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;

  .cell-wrap_item {
    // background-color: pink;
    margin-right: 1.8rem;
    margin-bottom: 1rem;
    display: flex;
    color: #c7c7c7;
    position: relative;
    align-items: center;
    flex-direction: column;

    .audit_close {
      position: absolute;
      top: 0;
      right: 0;
      width: 1rem;
      height: 1rem;
      text-align: center;
      line-height: 1rem;
      font-size: 0.6rem;
      background-color: #bac6d0;
      color: #fff;
      border-radius: 50%;
    }

    .audit_allow {
      position: absolute;
      top: 0;
      right: 0;
      width: 1rem;
      height: 1rem;
      text-align: center;
      line-height: 1rem;
      font-size: 0.6rem;
      background-color: #07c160;
      color: #fff;
      border-radius: 50%;
    }

    &::before {
      content: ". . .";
      position: absolute;
      color: #c7c7c7;
      height: 0.5rem;
      line-height: 0.1rem;
      top: 34%;
      transform: translateY(-50%);
      right: -1.5rem;
    }

    img {
      width: 4.4rem;
      height: 4.4rem;
      border-radius: 50%;
      background-color: #fff;
      margin-bottom: 0.3rem;
    }

    &:nth-child(3n) {
      margin-right: 0;
    }

    &:nth-child(3n)::before {
      color: transparent;
    }
  }

  .cell-wrap_add {
    width: 4.4rem;
    height: 4.4rem;
    border-radius: 50%;
    color: #c7c7c7
      /* 33/9.59 */
    ;
    margin-bottom: 1rem;
    line-height: 4.4rem;
    text-align: center;
    font-size: 1.8rem;
    border: 1px solid #c7c7c7;
  }
}

.dialog-wrap {

  //   padding: 20px;
  .wrap {
    padding: 10px;
    display: flex;
    flex-direction: column;

    .title {
      text-align: center;
      margin: 1rem 0;
      //   color: red;
    }

    .remak {
      outline: none;
      border: none;
      background: #f7f7fa;
      padding: 10px 15px;
      border-radius: 30px;
      margin: 10px 0 20px 0;
    }
  }
}

// 步骤条的样式
.fail {
  color: #fff;
  background-color: #969799;
  border-radius: 50%;
}

.success {
  color: #fff;
  background-color: #07c160;
  border-radius: 50%;
}

.cross {
  background-color: red;
  border-radius: 50%;
  color: #fff;
}

.fail_text {
  color: #969799;
}

.success_text {
  color: #07c160;
}

.cross_text {
  color: red;
}</style>
